import { type ReactNode, useContext } from 'react';
import { Box } from '@mui/material';

import { PracticeSettingsPageContext } from './PracticeSettings/practiceSettingsContext';
import { practiceSettingsTitleSx } from './PracticeSettings/practiceSettingsTypography';

type SectionCardTitleProps = {
  title: string;
  /** Sits inline after the title text; omit it when the card has no guide control. */
  control?: ReactNode;
};

/**
 * A practice-settings card title with its optional guide control after it
 * (GDN-3703, AC-13). Passed as `CardHeader`'s `title`, so the header still
 * supplies the title typography. The text sets the row height: the section
 * control (28px) is taller than a body line, so its block margin is pulled in
 * and the title keeps its place with and without the control. The text sits in
 * its own element, so the control is the title's next sibling on every card.
 */
export function SectionCardTitle({ title, control }: SectionCardTitleProps) {
  const isPage = useContext(PracticeSettingsPageContext);
  return (
    <Box
      component="span"
      sx={{ display: 'flex', alignItems: 'center', gap: 0.5, '& > button': { my: -0.5 } }}
    >
      <Box
        component={isPage ? 'h1' : 'span'}
        sx={isPage ? practiceSettingsTitleSx : { m: 0, font: 'inherit' }}
      >
        {title}
      </Box>
      {control}
    </Box>
  );
}
